import React, { useEffect, useState } from 'react';
import { Card, CardBody, Col, Container, Input, Label, Row, Button, Form, FormFeedback, Spinner } from 'reactstrap';
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth.js";

//redux

import { Link, useSearchParams } from "react-router-dom";
import withRouter from "@velzon/components/withRouter.js";
// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

import postHub from "../../assets/images/PostHubb-logo.svg";
import { resetPassword, validateToken } from 'api/authentication/auth.js';
import { toast } from 'react-toastify';

const ResetPassword = () => {
  const [params] = useSearchParams();
  const token = params.get("token");

  const [passwordShow, setPasswordShow] = useState(false);
  const [confirmPasswordShow, setConfirmPasswordShow] = useState(false);
  const [loading, setLoading] = useState(false)
  const [tokenValid, setTokenValid] = useState(null);
  const [errorMsg, setErrorMsg] = useState('')

  useEffect(() => {
    const validateTokenDetails = async () => {
      try {
        const res = await validateToken(token)
        if (res.is_valid) {
          setTokenValid(true);
        }
      } catch (err) {
        setTokenValid(false);
        const msg = err?.response?.data?.message || 'Invalid reset link';
        setErrorMsg(msg);
        setTimeout(() => {
          window.location.href = "/forgot-password";
        }, 2000);
      }
    };

    if (token) validateTokenDetails();
  }, [token])

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    validateOnMount: true,

    initialValues: {
      password: '',
      confirmPassword: ''
    },
    validationSchema: Yup.object({
      password: Yup.string()
        .required("Password is required")
        .min(6, "Password must be at least 6 characters")
        .matches(
          /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{6,}$/,
          "Must contain letters, numbers, and a special character"
        ),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("password")], "Passwords must match")
        .required("Confirm Password is required")
    }),
    onSubmit: async (values) => {
      setLoading(true)
      try {
        const payload = {
          token,
          newPassword: values.password
        }
        const response = await resetPassword(payload);
        setTokenValid(true)

        toast.success(response.message)
        window.location.href = "/login";
      } catch (error) {
        toast.error(error?.response?.data?.message || 'Password reset failed');
        setTimeout(() => {
          window.location.href = "/forgot-password";
        }, 2000);
      }finally{
        setLoading(false)
      }
    }
  });

  return (
    <React.Fragment>
      <ParticlesAuth>
        <div className="auth-page-content mt-lg-5">
          <Container>
            <Row>
              <Col lg={12}>
                <div className="text-center mt-sm-5 mb-4 text-white-50">
                  <div>
                    <Link to="/" className="d-inline-block auth-logo">
                      <img src={postHub} alt="" height="100" />
                    </Link>
                  </div>
                  {/* <p className="mt-3 fs-15 fw-medium">Premium Admin & Dashboard Template</p> */}
                </div>
              </Col>
            </Row>
            {tokenValid === null && (
              <div className="text-center mt-5">
                <h5>Validating reset link...</h5>
              </div>
            )}

            {tokenValid === false && (
              <div className="text-center mt-5">
                <h5 className="text-danger">{errorMsg || "Invalid or expired reset link."}</h5>
                <p>Redirecting to forgot password page...</p>
              </div>
            )}

            {tokenValid === true &&
              <Row className="justify-content-center">
                <Col md={8} lg={6} xl={5}>
                  <Card className="mt-4">
                    <CardBody className="p-4">
                      <div className="text-center mt-2">
                        <h5 className="text-primary">Please reset your password to continue</h5>
                        {/* <p className="text-muted">Please reset your password to continue</p> */}
                      </div>
                      {/* {error && error ? (<Alert color="danger"> {error} </Alert>) : null} */}
                      <div className="p-2 mt-4">
                        <Form
                          onSubmit={(e) => {
                            e.preventDefault();
                            validation.handleSubmit();
                            return false;
                          }}
                          action="#">

                          <div className="mb-3">
                            <Label className="form-label" htmlFor="password-input">Password</Label>
                            <div className="position-relative auth-pass-inputgroup mb-3">
                              <Input
                                name="password"
                                value={validation.values.password || ""}
                                type={passwordShow ? "text" : "password"}
                                className="form-control pe-5"
                                placeholder="Enter Password"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                invalid={
                                  validation.touched.password && validation.errors.password ? true : false
                                }
                              />
                              {validation.touched.password && validation.errors.password ? (
                                <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                              ) : null}
                              <button className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted" type="button" id="password-addon" onClick={() => setPasswordShow(!passwordShow)}><i className="ri-eye-fill align-middle"></i></button>
                            </div>
                          </div>

                          <div className="mb-3">
                            <Label className="form-label" htmlFor="password-input">Confirm Password</Label>
                            <div className="position-relative auth-pass-inputgroup mb-3">
                              <Input
                                name="confirmPassword"
                                value={validation.values.confirmPassword || ""}
                                type={confirmPasswordShow ? "text" : "password"}
                                className="form-control pe-5"
                                placeholder="Enter Password"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                invalid={
                                  validation.touched.confirmPassword && validation.errors.confirmPassword ? true : false
                                }
                              />
                              {validation.touched.confirmPassword && validation.errors.confirmPassword ? (
                                <FormFeedback type="invalid">{validation.errors.confirmPassword}</FormFeedback>
                              ) : null}
                              <button className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted" type="button" id="password-addon" onClick={() => setConfirmPasswordShow(!confirmPasswordShow)}><i className="ri-eye-fill align-middle"></i></button>
                            </div>
                          </div>

                          <div className="mt-4">
                            <Button
                              disabled={loading || !validation.isValid}
                              color="danger"
                              className="btn btn-danger w-100"
                              type="submit">
                              {loading ? (
                                <>
                                  <Spinner size="sm" className="me-2" />
                                </>
                              ) : (
                                "Reset Password"
                              )}
                            </Button>

                          </div>
                        </Form>
                      </div>
                    </CardBody>
                  </Card>

                </Col>
              </Row>
            }
          </Container>
        </div>
      </ParticlesAuth>
    </React.Fragment>
  );
};

export default withRouter(ResetPassword);